<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 17:26:40
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 14:47:27
 * @Description: 生成月报价
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\dialog\monthPriceDialog.vue
-->
<template>
  <el-dialog v-dialogDrag :visible.sync="monthPriceDialog" width="1300px" :append-to-body="true" :close-on-click-modal="false" :before-close="close" @open="openMethod">
    <span v-if="showType == 2" slot="title" class="dialog-title">生成月报价</span>
    <span v-else slot="title" class="dialog-title">生成结算价</span>
    <div style="margin: 15px 25px">
      <el-button size="mini" class="bottom_one" :disabled="isLook" @click="updatePriceDetail">更新数据</el-button>
    </div>
    <!-- 泵送数据 -->
    <div v-if="monthPriceData.adjustPriceType == 3" style="margin: 15px 0px">泵送:</div>
    <el-table
      :header-cell-style="{ background: '#f3f6f9' }"
      :cell-style="{ borderRight: 'none' }"
      border
      stripe
      style="width: 100%"
      :data="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? priceData.settlementPrices : priceData.specialPrices"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        :label="showType == 1 ? '产品' : '标号'"
        :prop="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? 'strengthGrade' : 'productName'"
      ></el-table-column>
      <el-table-column
        align="center"
        :label="showType == 1 ? '本期确认结算价' : '本期确认月报价'"
        :prop="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? 'confirmPrice' : 'settlementConfirmPrice'"
      >
        <template slot-scope="scope">
          <el-input
            v-if="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3"
            v-model="scope.row.confirmPrice"
            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
            :disabled="isLook"
            @input="scope.row.confirmPrice = $regExp.checkNum4(scope.row.confirmPrice)"
            @blur="scope.row.confirmPrice = $regExp.blurCheckNum(scope.row.confirmPrice)"
          ></el-input>
          <el-input
            v-else
            v-model="scope.row.settlementConfirmPrice"
            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
            :disabled="isLook"
            @input="scope.row.settlementConfirmPrice = $regExp.checkNum4(scope.row.settlementConfirmPrice)"
            @blur="scope.row.settlementConfirmPrice = $regExp.blurCheckNum(scope.row.settlementConfirmPrice)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        :label="showType == 1 ? '本期结算价' : '本期月报价'"
        :prop="monthPriceData.adjustPriceType == 2 || monthPriceData.adjustPriceType == 1 || monthPriceData.adjustPriceType == 3 ? 'price' : 'settlementPrice'"
      ></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '上月确认结算价' : '上月确认月报价'" prop="lastConfirmPrice"></el-table-column>
    </el-table>
    <!-- 非泵送数据 -->
    <div v-if="monthPriceData.adjustPriceType == 3" style="margin: 15px 0px">非泵送:</div>
    <el-table
      v-if="monthPriceData.adjustPriceType == 3"
      :header-cell-style="{ background: '#f3f6f9' }"
      :cell-style="{ borderRight: 'none' }"
      border
      stripe
      style="width: 100%"
      :data="priceData.settlementPriceTwos"
      tooltip-effect="dark"
    >
      <el-table-column align="center" :label="showType == 1 ? '产品' : '标号'" prop="strengthGrade"></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '本期确认结算价' : '本期确认月报价'" prop="confirmPrice">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.confirmPrice"
            onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
            :disabled="isLook"
            @input="scope.row.confirmPrice = $regExp.checkNum4(scope.row.confirmPrice)"
            @blur="scope.row.confirmPrice = $regExp.blurCheckNum(scope.row.confirmPrice)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '本期结算价' : '本期月报价'" prop="price"></el-table-column>
      <el-table-column align="center" :label="showType == 1 ? '上月确认结算价' : '上月确认月报价'" prop="lastConfirmPrice"></el-table-column>
    </el-table>
    <!-- 产品价格信息 -->
    <!-- 2.性能等级表格 -->
    <div v-if="monthPriceData.adjustPriceType != 4">
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="functionData" tooltip-effect="dark">
          <el-table-column prop="askName" label="性能等级" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 3.材料要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="materialData" tooltip-effect="dark">
          <el-table-column prop="askName" label="材料要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 4.特殊要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="specialData" tooltip-effect="dark">
          <el-table-column prop="askName" label="特殊要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 5.外加剂要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="admixtureData" tooltip-effect="dark">
          <el-table-column prop="askName" label="外加剂要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 6.其他要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="otherData" tooltip-effect="dark">
          <el-table-column prop="askName" label="其他要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 7.组合类型 -->
      <el-row style="margin-top: 20px">
        <el-button v-if="!isLook" class="bottom_all_two" @click="addProductComposePriceDig = true">添加其他组合</el-button>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="productComposePriceList" tooltip-effect="dark">
          <el-table-column prop="productName" label="组合类型" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
    </div>
    <!-- 特殊产品价格信息 -->
    <div style="margin-top: 10px">
      <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="productTypes" tooltip-effect="dark">
        <el-table-column v-for="(item, index) in table_other" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
          <template slot-scope="scope">
            <span v-if="item.label == '费用标准'">
              <span v-if="scope.row.costStandard == 1">按车收费</span>
              <span v-if="scope.row.costStandard == 0">不收费</span>
            </span>
            <span v-else-if="item.label == '不含税价格'">
              <span>{{ ((scope.row.priceIncludinTax * 1) / (1 + priceInfo.taxRate * 1)).toFixed(2) || "0.00" }}</span>
            </span>
            <span v-else>{{ scope.row[item.prop] || "*" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 同比例砂浆信息 -->
    <div style="margin-top: 10px">
      <span>同比例砂浆:{{ priceData.contractReadjustPricesResordVo.mortar.strengthGrade }}</span>
      <span style="margin-left: 50px">{{ priceData.contractReadjustPricesResordVo.mortar.type == 2 ? "固定金额:" : "倍数（%）:" }}{{ priceData.contractReadjustPricesResordVo.mortar.multiple }}</span>
    </div>
    <!-- 泵送价格信息 -->
    <div style="margin: 15px 0px; font-size: 16px">泵送费用:</div>
    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="priceInfo.pumpingCostsVo.costs || []" tooltip-effect="dark">
      <el-table-column align="center" label="泵机类型" prop="costsPumps">
        <template slot-scope="scope">
          {{ pumpNameConnect(scope.row.costsPumps) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="含税单价（元/m³）" prop="priceIncludinTax"></el-table-column>
      <el-table-column align="center" label="不含税单价（元/m³）" prop="priceExcludingTax"></el-table-column>
      <el-table-column align="center" label="最新调整价格（元/m）" prop="latestAdjustmentsPrice"></el-table-column>
    </el-table>
    <div style="margin-top: 10px">
      <span
        >单次泵送量不足{{ priceInfo.pumpingCostsVo.transportation ? priceInfo.pumpingCostsVo.transportation.square : "" }}m³，按{{
          priceInfo.pumpingCostsVo.transportation ? priceInfo.pumpingCostsVo.transportation.unitPrice : ""
        }}m³计。</span
      >
    </div>
    <!-- 超高层费用信息 -->
    <div style="margin: 15px 0px; font-size: 16px">超高层费用:</div>
    <el-table :header-cell-style="{ background: '#f3f6f9' }" border style="width: 100%" :data="fromDate3" tooltip-effect="dark">
      <el-table-column align="center" label="名称" width="220" prop="itemName"> </el-table-column>
      <el-table-column align="center" label="高度(米)" width="650">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
            <div>
              <div v-if="index == 0" class="itemdiv1">
                <el-input v-model="item.leftInterval" :disabled="true" style="width: 80px"></el-input>
                <el-select v-model="compare" :disabled="true" size="mini" style="width: 90px; margin-right: 10px" @change="save(item, 1, undefined, scope.row.children, $event, index, compare)">
                  <el-option :value="1" label="＜"></el-option>
                  <el-option :value="2" label="≤"></el-option>
                </el-select>
                <span style="padding: 5px; width: 60px">高度/臂长</span>
                <el-select v-if="compare == 2" v-model="scope.row.children[0].intervalType" :disabled="true" size="mini" style="width: 90px; margin-right: 10px">
                  <el-option :value="2" label="＜"></el-option>
                  <el-option :value="4" label="≤"></el-option>
                </el-select>
                <el-select v-if="compare == 1" v-model="scope.row.children[0].intervalType" :disabled="true" size="mini" style="width: 90px; margin-right: 10px">
                  <el-option :value="1" label="＜"></el-option>
                  <el-option :value="3" label="≤"></el-option>
                </el-select>
                <!-- <span style="padding:20px">小于</span> -->
                <el-input v-model="item.rightInterval" :disabled="true" type="Number" style="width: 120px" @change="save(item, 1, undefined, scope.row.children, $event, index)"></el-input>
                <el-button v-if="scope.row.children.length < 2 && false" size="mini" class="bottom_all" style="margin-left: 24px" @click="addfromDate3(scope.row, item, scope.row.children)">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
              </div>
              <div v-else-if="index == scope.row.children.length - 1" class="itemdiv1">
                <span style="padding: 5px; width: 60px">高度/臂长</span>
                <span style="padding: 20px; width: 28px">{{ scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2 ? "≥" : "＞" }}</span>
                <el-input v-model="item.leftInterval" disabled type="Number" style="width: 120px"></el-input>
                <div>
                  <el-button v-if="false" size="mini" style="margin-left: 24px" class="bottom_two" @click="delfromDate1(scope.row, index, item)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                  <el-button
                    v-if="scope.row.children.length > 1 && false"
                    size="mini"
                    class="bottom_all"
                    style="margin-left: 12px"
                    @click="addfromDate3(scope.row, item, scope.row.children, scope.row.children[index - 1].intervalType)"
                  >
                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                    添加
                  </el-button>
                </div>
              </div>
              <div v-else class="itemdiv1">
                <!-- <el-input v-model="scope.row.children[index-1].chargeStandard[1]" disabled style="width:100px"></el-input> -->
                <el-input v-model="item.leftInterval" disabled style="width: 80px"></el-input>
                <span style="padding: 5px; width: 28px">{{ scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2 ? "≤" : "＜" }}</span>
                <span style="padding: 5px; width: 60px">高度/臂长</span>
                <el-select
                  v-if="scope.row.children[index - 1].intervalType == 1 || scope.row.children[index - 1].intervalType == 2"
                  v-model="item.intervalType"
                  :disabled="true"
                  size="mini"
                  style="width: 90px; margin-right: 10px"
                  @change="save(item, 1, undefined, scope.row.children, $event, index)"
                >
                  <el-option :value="2" label="＜"></el-option>
                  <el-option :value="4" label="≤"></el-option>
                </el-select>
                <el-select
                  v-if="scope.row.children[index - 1].intervalType == 3 || scope.row.children[index - 1].intervalType == 4"
                  v-model="item.intervalType"
                  :disabled="true"
                  size="mini"
                  style="width: 90px; margin-right: 10px"
                  @change="save(item, 1, undefined, scope.row.children, $event, index)"
                >
                  <el-option :value="1" label="＜"></el-option>
                  <el-option :value="3" label="≤"></el-option>
                </el-select>
                <el-input
                  v-model="item.rightInterval"
                  :disabled="true"
                  type="Number"
                  style="width: 80px"
                  @change="(scope.row.children[index + 1].leftInterval = item.rightInterval), save(item, 1, undefined, scope.row.children, $event, index)"
                ></el-input>
                <div>
                  <el-button v-if="false" size="mini" style="margin-left: 24px" class="bottom_two" @click="delfromDate1(scope.row, index, item)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="含税增加费（元）">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.children" :key="index" class="divdiv">
            <div>
              <el-input
                v-model="item.money"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                :disabled="true"
                type="Number"
                style="width: 80px"
                @change="save(item, 1, 2)"
              ></el-input>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button v-if="!isLook" :disabled="buttonStatus" class="bottom_all" style="margin-left: 24px" @click="infoSubmitFun">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { savePrising,queryPatternList } from "@/api/internetSales/engineeringControl.js";
import { queryPriceDetail2, updatePriceDetail, saveOrUpdate } from "@/api/wise/Wise_contactsbusiness/contactPriceList.js";
export default {
  components: {},
  props: {
    monthPriceDialog: {
      type: Boolean,
      default: false,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    //1混凝土 2月报
    showType: {
      type: Number,
      default: 1,
    },
    //1已确认 0待确认
    sureStatus: {
      type: Number,
      default: 0,
    },
    //1调价周期记录 2信息价期数
    monthPriceType: {
      type: Number,
      default: 1,
    },
    //为信息价期数时,最外层的类型
    adjustPriceType: {
      type: Number,
      default: 1,
    },
    monthPriceData: {
      type: Object,
      default: () => {},
    },
    priceInfo: {
      type: Object,
      default: () => {},
    },
    // infoNumId: {
    //     type: String,
    //     default: '',
    // },
    // contractId: {
    //     type: String,
    //     default: '',
    // },
  },
  data() {
    return {
      priceData: {
        contractReadjustPricesResordVo: {
          productTypes: [],
          mortar: {
            multiple: 0,
            type: 1,
            strengthGradeId: "0001",
            strengthGrade: "相同强度",
          },
        },
      },
      priceData2: [],
      files: [],
      areaList: "",
      settlementPricesCopy: [],
      settlementPriceTwosCopy: [],
      specialPricesCopy: [],
      compare: 1, //用于判断超高层第一个符号 1小于 2小于等于
      fromDate3: [{ code: "", list: [{ code: "" }, { code: "" }, { code: "" }] }],
      table_other: [
        { label: "特殊产品", width: "auto", prop: "productName", status: true },
        { label: "费用标准", width: "auto", prop: "costStandard", status: true },
        { label: "含税价格", width: "auto", prop: "priceIncludinTax", status: true },
        { label: "不含税价格", width: "auto", prop: "priceExcludingTax", status: true },
      ],
      functionData: [], //性能等级
      materialData: [], //材料要求
      specialData: [], //特殊要求
      admixtureData: [], //外加剂要求
      otherData: [], //其他要求
      productComposePriceList: [], //组合类型
      productTypes: [], //特殊产品
      buttonStatus:false,
    };
  },
  watch: {
    priceInfo(val) {
      if (val.listAddCost) {
        let data3 = val.listAddCost.filter(res => res.item == 4);
        const setArr = (item, cur) => {
          cur.chargeStandard = cur.chargeStandard && cur.chargeStandard.length > 0 ? cur.chargeStandard.split(",") : [];
          if (item.some(res => res.itemId == cur.itemId)) {
            item[item.findIndex(res => res.itemId == cur.itemId)].children.push(cur);
          } else {
            let a = JSON.parse(JSON.stringify(cur));
            cur.children = [a];
            item.push(cur);
          }
          return item;
        };
        let arr3 = data3.reduce(setArr, []);
        this.fromDate3 = arr3;
        if (this.fromDate3.length == 0) {
          this.fromDate3 = [
            {
              contractId: "",
              chargeStandard: [],
              dataType: 1,
              id: "",
              item: 4,
              sortNum: 0,
              intervalType: "",
              leftInterval: "",
              rightInterval: "",
              itemId: "",
              itemName: "高层",
              itemType: "",
              money: 0,
              children: [
                {
                  contractId: "",
                  chargeStandard: [],
                  dataType: 1,
                  id: "",
                  item: 4,
                  sortNum: 0,
                  intervalType: "",
                  leftInterval: "",
                  rightInterval: "",
                  itemId: "",
                  itemName: "高层",
                  itemType: "",
                  money: 0,
                },
              ],
            },
          ];
        } else {
          this.compare = this.fromDate3[0].children[0].intervalType == 1 || this.fromDate3[0].children[0].intervalType == 3 ? 1 : 2;
        }
      }
    },
  },
  created() {},
  methods: {
    pumpNameConnect(arr) {
      let json = arr.reduce((pre, cur, index) => {
        pre = pre + (index > 0 ? "/" : "") + cur.pumpName;
        return pre;
      }, "");

      return json;
    },
    openMethod() {
      this.queryPriceDetail();
    },
    setData(resData) {
      this.priceData = resData;
      this.priceData.settlementPriceTwos = this.priceData.settlementPriceTwos || [];
      this.priceData.settlementPrices = this.priceData.settlementPrices || [];
      this.priceData.specialPrices = this.priceData.specialPrices || [];
      if (this.priceData.settlementPrices.length > 0) {
        this.priceData.settlementPrices.forEach(item => {
          if (!item.confirmPrice) {
            item.confirmPrice = item.price ? item.price : item.lastConfirmPrice;
          }
        });
      }
      if (this.priceData.settlementPriceTwos.length > 0) {
        this.priceData.settlementPriceTwos.forEach(item => {
          if (!item.confirmPrice) {
            item.confirmPrice = item.price ? item.price : item.lastConfirmPrice;
          }
        });
      }
      if (this.priceData.specialPrices.length > 0) {
        this.priceData.specialPrices.forEach(item => {
          if (!item.settlementConfirmPrice) {
            item.settlementConfirmPrice = item.settlementPrice ? item.settlementPrice : item.lastConfirmPrice;
          }
        });
      }
      this.settlementPricesCopy = JSON.parse(JSON.stringify(this.priceData.settlementPrices || []));
      this.settlementPriceTwosCopy = JSON.parse(JSON.stringify(this.priceData.settlementPriceTwos || []));
      this.specialPricesCopy = JSON.parse(JSON.stringify(this.priceData.specialPrices || []));
      this.functionData = resData.contractReadjustPricesResordVo.productAskMap.performanceGrade || [];
      this.materialData = resData.contractReadjustPricesResordVo.productAskMap.meterialRequirements || [];
      this.specialData = resData.contractReadjustPricesResordVo.productAskMap.specialRequirements || [];
      this.admixtureData = resData.contractReadjustPricesResordVo.productAskMap.admixtureRequirements || [];
      this.otherData = resData.contractReadjustPricesResordVo.productAskMap.otherRequirements || [];
      this.productComposePriceList = resData.contractReadjustPricesResordVo.productComposePriceList || [];
      this.productTypes = resData.contractReadjustPricesResordVo.productTypes || [];
    },
    queryPriceDetail() {
      queryPriceDetail2({ dataId: this.monthPriceData.id, type: this.monthPriceType }).then(res => {
        if (res.code == 1001) {
          this.setData(res.data);
        }
      });
    },
    updatePriceDetail() {
      this.$confirm("是否确认更新?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          updatePriceDetail({ dataId: this.monthPriceData.id, type: this.monthPriceType }).then(res => {
            if (res.code == 1001) {
              this.$message.success("更新成功!");
              this.setData(res.data);
            }
          });
        })
        .catch(() => {});
    },
    infoSubmitFun() {
      //已确认才进行判断
      if (this.sureStatus == 1) {
        let type3 = false;
        if (this.monthPriceData.adjustPriceType == 4) {
          this.priceData.specialPrices.forEach((item, index) => {
            if (item.productName != this.specialPricesCopy[index]?.productName) {
              type3 = true;
            } else {
              if (item.settlementConfirmPrice != this.specialPricesCopy[index]?.settlementConfirmPrice) {
                type3 = true;
              }
            }
          });
        } else {
          this.priceData.settlementPrices.forEach((item, index) => {
            if (item.strengthGrade != this.settlementPricesCopy[index]?.strengthGrade) {
              type3 = true;
            } else {
              if (item.confirmPrice != this.settlementPricesCopy[index]?.confirmPrice) {
                type3 = true;
              }
            }
          });
          if (this.monthPriceData.adjustPriceType == 3) {
            this.priceData.settlementPriceTwos.forEach((item, index) => {
              if (item.strengthGrade != this.settlementPriceTwosCopy[index]?.strengthGrade) {
                type3 = true;
              } else {
                if (item.confirmPrice != this.settlementPriceTwosCopy[index]?.confirmPrice) {
                  type3 = true;
                }
              }
            });
          }
        }
        if (!type3) {
          this.$message.warning("表格数据没有修改，不允许保存！");
          return;
        }
      }
      let type = false;
      let type2 = false; // 判断确认价范围在200-2000
      if (this.monthPriceData.adjustPriceType == 1 || this.monthPriceData.adjustPriceType == 2 || this.monthPriceData.adjustPriceType == 3) {
        if (this.priceData.settlementPrices.length > 0) {
          this.priceData.settlementPrices.forEach(item => {
            if (!item.confirmPrice && item.confirmPrice !== 0) {
              type = true;
            }
            if (item.confirmPrice < 150 || item.confirmPrice > 2000) {
              type2 = true;
            }
          });
        }
      } else {
        if (this.priceData.specialPrices.length > 0) {
          this.priceData.specialPrices.forEach(item => {
            if (!item.settlementConfirmPrice && item.settlementConfirmPrice !== 0) {
              type = true;
            }
            if (item.settlementConfirmPrice < 150 || item.settlementConfirmPrice > 2000) {
              type2 = true;
            }
          });
        }
      }
      if (this.monthPriceData.adjustPriceType == 3) {
        if (this.priceData.settlementPriceTwos.length > 0) {
          this.priceData.settlementPriceTwos.forEach(item => {
            if (!item.confirmPrice && item.confirmPrice !== 0) {
              type = true;
            }
            if (item.confirmPrice < 150 || item.confirmPrice > 2000) {
              type2 = true;
            }
          });
        }
      }
      if (type) {
        this.$message.warning("表格数据填写不完整！");
        return;
      }
      if (type2) {
        this.$message.warning("价格范围为200-2000！");
        return;
      }
      this.priceData.dataId = this.monthPriceData.id;
      this.priceData.dataSource = this.monthPriceType;
      this.priceData.adjustPriceType = this.monthPriceType == 1 ? this.monthPriceData.adjustPriceType : "";
      this.buttonStatus = true
      saveOrUpdate(this.priceData).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.close();
          
        }
        this.buttonStatus = false
      }).catch(() => {
        this.buttonStatus = false
      });
    },
    close() {
      this.$emit("closeMonthPriceDialog", false);
    },
    setMonthPrice(row) {
      console.log(row);
    },
  },
};
</script>

<style lang="scss" scoped>
.popperClass.el-date-picker {
  width: 220px;
}
</style>